// extracted by mini-css-extract-plugin
export default {"amountWrapperScrollBarContainer":"USlhe1","amountWrapper":"PxesQW","amountWrapperItemContainer":"xabKMb"};